import client from "./client";

const getBusiness= () => client.get("business/all/paginated?");

export default { getBusiness };
